module.exports = __webpack_public_path__ + "img/menu3.016dfcf0.png";